import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import CameraPlaceholder from "../Icons/cameraplaceholder";
import { useEffect, useRef, useState } from "react";
import MicOn from "../Icons/micon";
import MicOff from "../Icons/micoff";
import "./interview.css";
import "./camerasectioninterview.css";
import { useLocation } from "react-router-dom";

export function CameraSection({
  videoRef,
  cameraReady,
  micReady,
  isRunning,
  timer,
  isMicrophoneEnabled,
  startInterview,
  isAliSpeaking,
  isConnecting
}) {
  const hasStarted = useRef(false);
  const location = useLocation();

  const timeLeft = Math.max(0, location?.state?.assessmentDurationInSeconds - timer);

  useEffect(() => {
    if (!hasStarted.current && cameraReady && micReady) {
      startInterview();
      hasStarted.current = true;
    }
  }, [cameraReady, micReady, startInterview]);


  return (
    <Paper className="cameracasection_interview">
      {/* Camera Container */}
      <Box className="camera_video_container_interview">
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted
          className={`camerca_interview ${cameraReady ? "" : "hidden_camera_interview"}`}
        />


        {/* Show placeholder when camera is not ready */}
        {!cameraReady && (
          <Box className="camera_placeholder_interview">
            <CameraPlaceholder />
            <Typography variant="body2" color="textSecondary">
              Camera not available
            </Typography>
          </Box>
        )}

        {/* Recording indicator - Top Left */}
        {isRunning && cameraReady && !isConnecting && (
          <Box className="recording_indicator_overlay">
            <Box className="recording_dot" />
            <Typography className="recording-indicator-timer">
              Recording {timeLeft > 0 ? `${Math.floor(timeLeft / 60)}:${String(Math.floor(timeLeft) % 60).padStart(2, '0')}` : '0:00'}
            </Typography>
          </Box>
        )}

        {/* User Name Label - Bottom Left */}
        {cameraReady && (
          <Box className="user_name_label">
            <Typography className="user-name-label-text">
              You
            </Typography>
            {!isAliSpeaking && !isConnecting && isMicrophoneEnabled ? <MicOn fill="#fff" className="user-name-label-icon" /> : <MicOff fill="#fff" className="user-name-label-icon" />}
          </Box>
        )}

        {/* Microphone Status Message - Center Bottom */}
        {cameraReady && (
          <Box className="microphone_status_message_interview">
            <Typography className="microphone_message_text_interview">
              {isConnecting && "Interviewer is connecting..."}
              {!isConnecting && isAliSpeaking && "Alisha is Speaking"}
              {!isConnecting && !isAliSpeaking && isMicrophoneEnabled && "Speak now"}
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
} 